import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * Comment toggle + textarea, shared by diff and content flows.
 * - Shows "Add / View/Edit / Hide Comment" button
 * - Optionally disables textarea when rating === "UNRATED" (diff)
 * - Keeps your existing classNames to avoid CSS churn
 */
const RatingComment = ({
    canEdit,
    id,
    isOpen,
    onToggle,
    commentValue,
    onChange,
    placeholder = "Add a comment for this item",
    rows = 2,
    classNameWrapper,
    rating
}) => {
    const disabled = rating === "UNRATED" || typeof rating === "undefined" || rating === "";
    let buttonText;
    if (isOpen) buttonText = "Hide ";
    else if (commentValue) buttonText = "View/Edit ";
    else buttonText = "Add ";

    return (
        <>
            <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-start" }}>
                <button className="toggle-subject-comment-btn-student" onClick={onToggle} type="button">
                    {buttonText}Comment
                </button>
            </div>

            {isOpen && (
                <div
                    className={classNames("subject-comment-wrapper", isOpen ? "show" : "hide", classNameWrapper)}
                    style={{ marginTop: 8 }}
                >
                    <label htmlFor={`comment-${id}`} className="visually-hidden">
                        Add comment for this item
                    </label>
                    <textarea
                        className="comment-textarea"
                        id={`comment-${id}`}
                        value={commentValue}
                        onChange={(e) => onChange(e.target.value)}
                        rows={rows}
                        placeholder={placeholder}
                        disabled={disabled || !canEdit}
                    />
                </div>
            )}
        </>
    );
};

RatingComment.propTypes = {
    canEdit: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    commentValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classNameWrapper: PropTypes.string,
    placeholder: PropTypes.string,
    rating: PropTypes.string,
    rows: PropTypes.number
};

RatingComment.defaultProps = {
    classNameWrapper: "",
    placeholder: "Add a comment for this item",
    rating: undefined,
    rows: 2
};

export default RatingComment;
